export default __webpack_public_path__ + "static/media/exportHover.a9804aed.svg";